<template lang="pug">
  .b2b-page-cmr-emits
    ods-module.box-card
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("cmr.cmr_entity_table_detail.download_pdf")', placement='bottom')
                  ods-button(
                    v-show='deliveryCmrForm.hasPdf != null && deliveryCmrForm.hasPdf == true',
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadCmrPdf')
                    | {{ $t('order.order_detail.download_pdf_buttons') }}
              // ods-tooltip(:content='$t("cmr.cmr_entity_table_detail.download_original")', placement='bottom') // Se comenta este boton por FNX-5044
                  ods-button(
                    v-if='deliveryCmrForm.originalFilePath'
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadCmrOriginal')
                    | {{ $t('cmr.cmr_entity_table_detail.download_original') }}
              // ods-tooltip(:content='$t("invoice_detail.buttons.download_original_formatted_tooltip")', placement='bottom') // Se comenta este boton por FNX-5044
                  ods-button(
                    v-if='deliveryCmrForm.originalFilePath'
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadOriginalformatted')
                    | {{ $t('invoice_detail.buttons.download_original_formatted') }}
              ods-tooltip(:content='$t("cmr.cmr_entity_table_detail.download_metadata")', placement='bottom')
                  ods-button(
                    v-if='deliveryCmrForm.metadataPath && canAdminIndra'
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadCmrMetadata')
                    | {{ $t('cmr.cmr_entity_table_detail.download_metadata') }}

              ods-tooltip(:content='$t("deliverynote.deliverynote_detail.rejected_deliverynote_buttons_tooltip")', placement='bottom')
                  div
                    ods-button(
                      v-if='canChangeStatusCMR && (deliveryStatus === "RECEIVED" || deliveryStatus === "ACCEPTED")',
                      icon='ods-icon-disable',
                      size='small',
                      circle,
                      @click.native='isShowDialogRejectedDeliveryNote = true')
                      | {{ $t('deliverynote.deliverynote_detail.rejected_deliverynote_buttons') }}
              ods-tooltip(:content='$t("deliverynote.deliverynote_detail.activate_deliverynote_buttons_tooltip")', placement='bottom')
                div
                  ods-button(
                    v-if='canChangeStatusCMR && (deliveryStatus === "REJECTED" || deliveryStatus === "RECEIVED")',
                    icon='ods-icon-checkmark-2',
                    size='small',
                    circle,
                    @click.native='goActivateCmr()')
                    | {{ $t('deliverynote.deliverynote_detail.activate_deliverynote_buttons') }}
      ods-form(
        ref='deliveryCmrForm',
        :model='deliveryCmrForm',
        :rules='rulesDeliveryCmrForm'
        label-width='14rem',
        label-position='top',
        size='small',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              prop='shipperName',
              :label='$t("cmr.cmr_entity_table_detail.shipper")')
              ods-input(
                :disabled='true',
                v-model='deliveryCmrForm.shipperName')
            ods-form-item(
              prop='partyFromName',
              :label='$t("cmr.cmr_entity_table_detail.load")')
              ods-input(
                :disabled='true',
                v-model='deliveryCmrForm.partyFromName')
            ods-form-item(
              prop='partyFromCode',
              :label='$t("cmr.cmr_entity_table_detail.loadcode")')
              ods-input(
                :disabled='true',
                v-model='deliveryCmrForm.partyFromCode')
            ods-form-item(
              prop='partyFromData',
              :label='$t("cmr.cmr_entity_table_detail.loaddirection")')
              ods-input(
                :disabled='true',
                v-model='deliveryCmrForm.partyFromData')
            ods-form-item(
              prop='chargerObservations',
              :label='$t("cmr.cmr_entity_table_detail.charger_observations")')
              ods-input(
                :disabled='!(canEditCMR && changeCmrData)'
                v-model='deliveryCmrForm.chargerObservations')
            ods-form-item(
              prop='creationDateTime',
              :label='$t("order.order_entity_table.date_creation")')
              ods-input(
                :disabled='true',
                v-model='creationDateTimeFormatted')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              prop='buyerName',
              :label='$t("cmr.cmr_entity_table_detail.buyer")')
              ods-input(
                :disabled='true',
                v-model='deliveryCmrForm.buyerName')
            ods-form-item(
              prop='partyToName',
              :label='$t("cmr.cmr_entity_table_detail.delivery")')
              ods-input(
                :disabled='true',
                v-model='deliveryCmrForm.partyToName')
            ods-form-item(
              prop='partyToCode',
              :label='$t("cmr.cmr_entity_table_detail.deliverycode")')
              ods-input(
                :disabled='true',
                v-model='deliveryCmrForm.partyToCode')
            ods-form-item(
              prop='partyToData',
              :label='$t("cmr.cmr_entity_table_detail.deliverydirection")')
              ods-input(
                :disabled='true',
                v-model='deliveryCmrForm.partyToData')
            ods-form-item(
              prop='sendDate',
              :label='$t("cmr.cmr_entity_table_detail.send_date")')
              ods-input(
                :disabled='true',
                v-model='sendDateFormatter')
        //- DATOS TRANSPORTISTA
        .block
          span.subtitle {{ $t('cmr.cmr_entity_table_detail.transportist_data') }}
          ods-row(type='flex')
            ods-col(:span='10')
              ods-form-item(
                :label='$t("cmr.cmr_entity_table_detail.transportist_name")',
                prop='nameTransportist')
                ods-input(
                  :disabled='!(canEditCMR && changeCmrData)'
                  v-model='deliveryCmrForm.nameTransportist')
              ods-form-item(
                :label='$t("cmr.cmr_entity_table_detail.transportist_email")',
                prop='emailTransportist')
                ods-input(
                  :disabled='!(canEditCMR && changeCmrData)'
                  v-model='deliveryCmrForm.emailTransportist')
              ods-form-item(
                prop='vehiclePlate',
                :label='$t("cmr.cmr_entity_table_detail.plate")')
                ods-input(
                  :disabled='!(canEditCMR && changeCmrData)'
                  v-model='deliveryCmrForm.vehiclePlate')
            ods-col(:span='4')
            ods-col(:span='10')
              ods-form-item(
                :label='$t("cmr.cmr_entity_table_detail.transportist_nif")',
                prop='nifTransportist')
                ods-input(
                  :disabled='!(canEditCMR && changeCmrData)'
                  v-model='deliveryCmrForm.nifTransportist')
              ods-form-item(
                prop='transportistObservations',
                :label='$t("cmr.cmr_entity_table_detail.transportist_observations")')
                ods-input(
                  :disabled='!(canEditCMR && changeCmrData)'
                  v-model='deliveryCmrForm.transportistObservations')
              ods-form-item(
                prop='trailerPlate',
                :label='$t("cmr.cmr_entity_table_detail.trailerplate")')
                ods-input(
                  :disabled='!(canEditCMR && changeCmrData)'
                  v-model='deliveryCmrForm.trailerPlate')
          ods-row(type='flex')
            ods-col(:span='10')
              ods-form-item(
                v-if='canChangeStatusCMR && changeCmrData',
                :label='$t("cmr.cmr_entity_table_detail.change_state.label")',
                prop='statusCode')
                ods-select(
                  :no-match-text='$t("msg_generics.no_match")',
                  v-model='deliveryCmrForm.statusCode',
                  :disabled='!(canChangeStatusCMR && changeCmrData)'
                  filterable,
                  clearable,
                  :placeholder='$t("cmr.cmr_entity_table_detail.change_state.placeholder")'
                  @change='changeStatus')
                  ods-option(
                    v-for='option in optionsFilterStatusDelivery',
                    :key='option.id',
                    :label='$t("cmr_status." + option.code)',
                    :value='option.code')
            ods-col(:span='4')
            ods-col(:span='10')
              ods-form-item(
                v-if='canChangeStatusCMR && deliveryCmrForm.statusCode && changeCmrData'
                :label='$t("invoice_detail.invoice_detail_edit_form.observations")',
                prop='observations')
                ods-input(v-model='deliveryCmrForm.observations')
    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            v-if='(canEditCMR || anChangeStatusCMR) && changeCmrData',
            type='primary',
            size='large'
            @click='submitCmrDetailEditForm("deliveryCmrForm")')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnClear")', placement='bottom')
          ods-button(
            v-if='(canEditCMR || anChangeStatusCMR) && changeCmrData',
            ref='buttonCancel',
            size='large'
            type='neutral',
            @click='cancelCmrDetailEditForm')
            | {{ $t('buttons.btnClear') }}

    ods-module.collapse
      ods-accordion(v-model='activateLines', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('cmr.cmr_entity_table_detail.cmrlines') }}
            span.info(v-show='!deliveryCmrForm.cmrLines || !deliveryCmrForm.cmrLines.length') {{ $t('cmr.cmr_entity_table_detail.cmrnolines') }}

          //- Tabla lineas cmr
          ods-table(
            v-if='deliveryCmrForm.cmrLines && deliveryCmrForm.cmrLines.length > 0 ',
            :data='deliveryCmrForm.cmrLines',
            :default-sort="{prop: 'lineNumber', order: 'ascending'}",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='lineNumber',
              width='100',
              :label='$t("cmr.cmr_entity_table_detail.line")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='description',
              width='400',
              :label='$t("order.order_entity_table_detail.description")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='lineCode',
              :label='$t("cmr.cmr_entity_table_detail.linecode")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='lineCodeSeller',
              :label='$t("cmr.cmr_entity_table_detail.linecodeseller")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='numPackage',
              :label='$t("cmr.cmr_entity_table_detail.numpackages")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='weight',
              :label='$t("cmr.cmr_entity_table_detail.weight")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='measure',
              :label='$t("order.order_entity_table_detail.measure")',
              :show-overflow-tooltip='true',
              sortable='')

    ods-module.collapse
      ods-accordion(v-model='cmrEvents', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('cmr.cmr_entity_table_detail.events') }}
            span.info(v-show='!cmrEvents.length') {{ $t('invoice_detail.events.no_events') }}
            i(class='header-icon ods-icon-information')
          ods-row()
            b2b-timelineextend(:events='cmrEvents')
    ods-module.collapse
      ods-accordion(@change="loadHistory")
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('cmr.cmr_entity_table_detail.history') }}
            span.info(v-show='!cmrHistory.length && historyMessage') {{ $t('cmr.cmr_entity_table_detail.no_history') }}
          //- Tabla de histórico
          ods-table(
            v-if='cmrHistory.length > 0 ',
            :data='cmrHistory',
            :default-sort='{ prop: "creationDateTime", order: "descending" }',
            style='width: 100%',
            @cell-mouse-enter='handleCellHistoryMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='description',
              width='670',
              :label='$t("cmr.cmr_entity_table_detail.description")',
              align='left',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='creationDateTime',
              width='210',
              :label='$t("cmr.cmr_entity_table_detail.creation_date")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              width='80')
              template(slot-scope='scope')
                ods-tooltip(:content='$t("buttons.btnDownload")', placement='bottom')
                  ods-button.first-button(
                    type='neutral',
                    @click='downloadHistoryPdf')
                    ods-icon(name='download', size='16')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimelineextend from '@/views/cmr/B2bTimelineExtend'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-cmr-emits',
  mixins: [Utils],
  data () {
    return {
      changeCmrData: false,
      updateDataCmr: true,
      activateLines: ['1'],
      deliveryNotesEmitLine: [],
      optionsFilterStatusDelivery: [],
      cmrEvents: [],
      cmrHistory: [],
      currentRowCmrHistory: {},
      historyFlag: true,
      historyMessage: false,
      deliveryNotesEmitLineOriginal: [],
      deliveryStatus: null,
      measureUnit: '',
      dialogNewLineDeliveryNoteForm: {
        description: null,
        quantity: '',
        priceUnit: '',
        measure: null
      },
      deliveryCmrForm: {
        buyerName: null,
        sellerName: null,
        cmrNumber: null,
        plate: null,
        issueDateTime: '',
        creationDateTime: '',
        documentStatus: null,
        projectName: null,
        statusId: null,
        hasPdf: null
      },

      viewUpdate: false,

      deliveryLineChanged: {
        id: null,
        idDeliveryNote: null,
        status: null,
        lineNumber: null,
        itemCode: null,
        quantity: null,
        unitPrice: null,
        totalAmount: null,
        deliveryDate: null,
        documentStatus: null
      },

      currentRow: {},
      deliveryLinesChanged: [],
      isShowDialogCheckLine: false,
      isShowDialogCheckLineEdit: false,
      // Rechazo de palbaranes
      isShowDialogRejectedDeliveryNote: false,
      dialogRejectedDeliveryNoteForm: {
        motive: null
      },
      optionsMeasure: [],
      searchMeasure: [],
      dialogNewLineEditDeliveryNoteForm: {
        description: null,
        quantity: '',
        priceUnit: '',
        measure: null,
        deliveryIdLine: null
      }
    }
  },

  components: {
    B2bTimelineextend
  },

  computed: {
    ...mapGetters([
      // Permisos
      'canChangeStatusCMR',
      'canEditCMR',
      'canAdminIndra'
    ]),
    rulesDeliveryCmrForm () {
      const validateEmail = (rule, value, callback) => {
        if (this.checkCorrectEmail(value)) { // eslint-disable-line
          callback()
        } else if (value == null || value === '') { // eslint-disable-line
          callback()
        } else {
          callback(new Error(this.$t('msg_generics.emailKo')))
        }
      }
      return {
        chargerObservations: [{
          max: 1500,
          message: this.$t('validations.maxlenght', { maxlenght: 1500 }),
          trigger: 'change'
        }],
        transportistObservations: [{
          max: 1500,
          message: this.$t('validations.maxlenght', { maxlenght: 1500 }),
          trigger: 'change'
        }],
        nameTransportist: [{
          required: true,
          message: this.$t('msg_generics.field_required'),
          trigger: 'change'
        },
        {
          max: 150,
          message: this.$t('validations.maxlenght', { maxlenght: 150 }),
          trigger: 'change'
        }],
        nifTransportist: [{
          required: true,
          message: this.$t('msg_generics.field_required'),
          trigger: 'change'
        },
        {
          max: 50,
          message: this.$t('validations.maxlenght', { maxlenght: 50 }),
          trigger: 'change'
        }],
        emailTransportist: [
          { max: 255, message: this.$t('validations.maxlenght', { maxlenght: 255 }), trigger: 'change' },
          { validator: validateEmail, trigger: 'change' }
        ],
        vehiclePlate: [{
          max: 50,
          message: this.$t('validations.maxlenght', { maxlenght: 50 }),
          trigger: 'change'
        }],
        trailerPlate: [{
          max: 50,
          message: this.$t('validations.maxlenght', { maxlenght: 50 }),
          trigger: 'change'
        }],
        observations: [{
          max: 256,
          message: this.$t('validations.maxlenght', { maxlenght: 256 }),
          trigger: 'change'
        }]
      }
    },
    // Formatear metodo de envio
    receptCommMethodFormatted (row, column) {
      if (this.deliveryCmrForm.receptCommMethod) {
        const receptValue = this.deliveryCmrForm.receptCommMethod
        return this.$t('communication_method.' + receptValue)
      } else return ''
    },
    sendDateFormatter () { // eslint-disable-line
      if (this.deliveryCmrForm.sendDate) {
        const date = moment(this.deliveryCmrForm.sendDate)
        return date.format(this.$t('date_format'))
      }
    },
    creationDateTimeFormatted () { // eslint-disable-line
      if (this.deliveryCmrForm.creationDateTime) {
        const date = moment(this.deliveryCmrForm.creationDateTime)
        return date.format(this.$t('date_format_long'))
      }
    }
  },

  methods: {
    ...mapActions([
      'getCmrDetail',
      'getCmrEvents',
      'getCmrHistory',
      'modifyCmr',
      'rejectedDeliveryNote',
      'downloadCmrPdfMultiple',
      'downloadCmrHistoryPdf',
      'downloadCmrOriginal',
      'downloadCmrFormatted',
      'downloadCmrMetadata',
      'getProjectStatusConfig'
    ]),

    cancelChanges () {
      this.viewUpdate = false
      this.deliveryLinesChanged = []
      this.resetBorderColor()
    },

    resetBorderColor () {
      // get element by class
      const arr = document.getElementsByClassName('ods-button ods-tooltip bordered')

      // store length in variable
      // some say accessing .length in a loop condition adds overhead
      const arrLen = arr.length

      // loop through all found elements
      for (let i = 0; i < arrLen; i++) {
        if (arr[i].style) {
          arr[i].style.border = ''
        }
      }
    },
    formatterStatus (row, column) {
      return row.status != null ? this.$t('cmr_status.' + row.status) : null
    },
    formatterDecimal (row, column) {
      if (row[column.property] == null) {
        return this.$t('msg_generics.no_price')
      } else if (row[column.property] || row[column.property] == 0) { // eslint-disable-line
        return this.$n(row[column.property], 'decimal')
      }
      return ''
    },
    formatterQuantity (row, column) {
      if (row[column.property]) {
        return this.$n(row[column.property], 'three_decimal')
      }
      return ''
    },
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    //  Reseteo al cerrar dialogo
    handleCloseDialog () {
      this.$refs.formDialogRejectedDeliveryNoteForm.resetFields()
    },
    // Descarga de pdf
    async handleDownloadCmrPdf () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const params = {
          cmrIds: [this.$route.params.cmrId]
        }
        const filename = await this.downloadCmrPdfMultiple(params)
        this.$notify({
          title: this.$t('order.order_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // si hay cambio de estado se solicita confirmación
    submitCmrDetailEditForm (formName) {
      if (this.deliveryCmrForm.statusCode) {
        this.updateDataCmr = false
        this.$confirm(this.$t('cmr.cmr_entity_table_detail.confirm_update_status'), {
          confirmButtonText: this.$t('buttons.btnOk'),
          cancelButtonText: this.$t('buttons.btnCancel'),
          showCancelButton: true,
          center: true,
          iconClass: 'ods-icon-warning'
        }).then(async () => {
          this.updateCmrDetailEditForm(formName)
        }).catch(() => {})
      } else {
        this.updateCmrDetailEditForm(formName)
      }
    },
    updateCmrDetailEditForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid && this.$route.params.cmrId && this.$route.params.cmrId != '_blank') {// eslint-disable-line
          const load = this.$loading({
            lock: true,
            text: this.$t('cmr.cmr_entity_table_detail.update_cmr')
          })
          console.log('submitCmrDetailEditForm: ', this.invoiceDetailEditForm)
          try {
            const params = {
              cmrId: this.$route.params.cmrId,
              cmrNumber: this.deliveryCmrForm.cmrNumber,
              chargerObservations: this.deliveryCmrForm.chargerObservations,
              nameTransportist: this.deliveryCmrForm.nameTransportist,
              emailTransportist: this.deliveryCmrForm.emailTransportist,
              nifTransportist: this.deliveryCmrForm.nifTransportist,
              transportistObservations: this.deliveryCmrForm.transportistObservations,
              vehiclePlate: this.deliveryCmrForm.vehiclePlate,
              trailerPlate: this.deliveryCmrForm.trailerPlate,
              statusCode: this.deliveryCmrForm.statusCode,
              observations: this.deliveryCmrForm.observations
            }

            await this.modifyCmr(params)
            // Refrescamos

            await this.getCmrOnDatabase()
            await this.getCmrEventsOnDatabase()

            this.$refs.deliveryCmrForm.clearValidate()

            this.$notify({
              title: this.$t('cmr.cmr_entity_table_detail.submit_edit_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('submitCmrDetailEditForm CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('submitCmrDetailEditForm: ', this.invoiceDetailEditForm)
          return false
        }
      })
    },
    async cancelCmrDetailEditForm () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        this.$refs.buttonCancel.$el.blur()
        await this.getCmrOnDatabase()
      } finally {
        load.close()
      }
    },
    // Descarga de pdf
    async downloadHistoryPdf () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const params = {
          cmrHistoryId: this.currentRowCmrHistory.id
        }
        const filename = await this.downloadCmrHistoryPdf(params)
        this.$notify({
          title: this.$t('order.order_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    handleCellHistoryMouseEnter (row, column, cell, event) {
      this.currentRowCmrHistory = row
    },
    // Descarga de original
    async handleDownloadCmrOriginal () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const params = {
          cmrId: this.$route.params.cmrId
        }
        const filename = await this.downloadCmrOriginal(params)
        this.$notify({
          title: this.$t('order.order_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleDownloadOriginalformatted () {
      console.log('handleDownloadOriginalformatted: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_formatted')
      })
      try {
        const filename = await this.downloadCmrFormatted(
          this.$route.params.cmrId
        )
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOriginalformatted CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Descarga de metadata
    async handleDownloadCmrMetadata () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const params = {
          cmrId: this.$route.params.cmrId
        }
        const filename = await this.downloadCmrMetadata(params)
        this.$notify({
          title: this.$t('order.order_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async loadHistory () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
      // Get historico
        if (this.historyFlag) {
          this.historyFlag = false
          this.cmrHistory = await this.getCmrHistory(this.$route.params.cmrId)
          console.log('El histórico del cmr: ', this.cmrHistory)
          this.historyMessage = true
        }
      } finally {
        load.close()
      }
    },
    changeStatus (data) {
      this.optionsFilterStatusDelivery.find(function (t) {
        return t.id === data
      })
      this.$refs.deliveryCmrForm.clearValidate()
    },
    async getProjectStatusCMR () {
      try {
        const dataQuery = {
          serviceId: this.serviceId,
          webmodule: 'CMR'
        }
        const response = await this.getProjectStatusConfig(dataQuery)
        console.log('getProjectStatusCMR', response)
        this.optionsFilterStatusDelivery = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    // eventos de un cmr
    async getCmrEventsOnDatabase () {
      try {
        const response = await this.getCmrEvents(this.$route.params.cmrId)
        this.cmrEvents = response.data
        console.log('cmrEvents', this.cmrEvents)
        console.log('cmrEvents', this.cmrEvents.length)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    // Detalle cmr
    async getCmrOnDatabase () {
      try {
        this.deliveryCmrForm = await this.getCmrDetail(this.$route.params.cmrId)

        // Guardamos estado
        this.deliveryStatus = this.deliveryCmrForm.status.status
        // Formateamos estado
        if (this.deliveryStatus != null && this.deliveryStatus === 'REJECTED' && this.deliveryCmrForm.rejectSeller) {
          const REJECTED_SELLER = 'REJECTED_SELLER'
          this.deliveryCmrForm.statusId = this.$t('cmr_status.' + REJECTED_SELLER)
        } else {
          this.deliveryCmrForm.statusId = this.$t('cmr_status.' + this.deliveryCmrForm.statusId)
        }
        this.changeCmrData = this.deliveryStatus !== 'ANNULLED' && this.deliveryStatus !== 'SENT'
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      // Detalle cmr
      await this.getCmrOnDatabase()
      await this.getCmrEventsOnDatabase()
      await this.getProjectStatusCMR()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-cmr-emits {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }

    .subtitle{
        margin-top: 10px;
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;
      }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .ods-button:not(.is-circle) i, .ods-button:not(.is-circle) [class*="ods-icon-"], .ods-button:not(.is-circle) [class*=" ods-icon-"] {
      margin-top: -2px;
      margin-left: 0px;
  }
  .collapse{
    margin-top: 25px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table{
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
      ::v-deep .ods-button{
      background-color: #FFF;
      border-color: #FFF;
      color: #000;
      }
      ::v-deep .ods-input-number .ods-input__inner {
        padding: 4px 30px 4px 8px;
        text-align: right;
      }
    }
    ::v-deep .ods-input.is-disabled .ods-input__inner{
      background-color: transparent;
      border-color: transparent;
      color: black;
      cursor: not-allowed;
      text-align: right;
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
}
</style>
